import {
  GridFilterInputValue,
  type GridFilterOperator,
} from "@mui/x-data-grid-premium";
import { NumberFilterModeEnum } from "@exonn/js-sdk";

export const getDataGridNumberFilterOperators = (): GridFilterOperator[] => {
  return [
    {
      value: NumberFilterModeEnum.Between,
      getApplyFilterFn: (filterItem) => {
        return (value) => {
          if (!filterItem.value) {
            return true;
          }
          if (
            typeof filterItem.value === "string" &&
            filterItem.value.includes("bis")
          ) {
            const range = filterItem.value
              .split("bis")
              .map((value) => value.trim());
            if (range[0] != null && range[1] != null) {
              return +range[0] <= value && value <= +range[1];
            }
          }
          if (
            typeof filterItem.value === "string" &&
            filterItem.value.includes("to")
          ) {
            const range = filterItem.value
              .split("to")
              .map((value) => value.trim());
            if (range[0] != null && range[1] != null) {
              return +range[0] <= value && value <= +range[1];
            }
          }
          return filterItem.value == value;
        };
      },
      label: "",
      headerLabel: "",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: "number" },
    },
  ];
};
